export class Exercise {
  exerciseId : number;
  description : string;
  startDateExercise: Date;
  endDateExercise: Date;
}
